export const ignoreErrors = [
    'Suspense Exception: This is not a real error!',
    'fbq is not defined',
    "Can't find variable: fbq",
    "Can't find variable: gmo",
    // A third-party script tries to use an iOS-only API (webkit.messageHandlers) that doesn’t exist in Facebook/Instagram’s browser.
    "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
    "undefined is not an object (evaluating 'window.webkit.messageHandlers[t].postMessage')",

    // React hydration mismatches
    /Hydration failed because the initial UI does not match what was rendered on the server/,
    /hydration/i,

    // ResizeObserver loop warnings (harmless rendering quirk)
    /ResizeObserver loop limit exceeded/,

    // Ignore the GIF‑instead‑of‑JSON parse error from the HubSpot FB loader
    /Unexpected token 'G', "GIF[^"]*" is not valid JSON/,

    // Ignore script load failures from jsDelivr CDN (e.g., hls.js or other assets)
    /^Failed to load https:\/\/cdn\.jsdelivr\.net/,

    // Ignore intermittent Google Maps internal module load error ("onion")
    /^Could not load "onion"\.$/,

    // Ignore Android WebView (Instagram/Facebook) error due to destroyed Java bridge
    /^Java object is gone$/,
]
